import { humanReadableValue } from '@rematter/ui-web';

import { InventoryItemButton } from '../InventoryItemButton';

import { InventoryTagData } from './_InventoryItemsModal';

export type InventoryTagOption = {
  id: string;
  label: string;
  mnemonic: string;
  colorHue?: number;
  group: string;
  extraInfo: string;
  tagData: InventoryTagData;
};

export type InventoryItemsModalTagsGridProps = {
  tags: InventoryTagOption[];
  selectedId?: string | null;
  onSelectTag: (tagId: string, tagData: InventoryTagData) => void;
  emptyMessage?: string;
};

export const InventoryItemsModalTagsGrid = ({
  tags,
  selectedId,
  onSelectTag,
  emptyMessage,
}: InventoryItemsModalTagsGridProps) => {
  if (tags.length === 0 && emptyMessage) {
    return (
      <div className="col-span-full flex items-center justify-center py-8 text-neutral/50">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="@InventoryItemsModalTagsGrid grid w-full grid-cols-3 gap-2">
      {tags.map((tag) => (
        <InventoryItemButton
          key={tag.id}
          isSelected={tag.id === selectedId}
          className="justify-between"
          overrideGroupStyle
          align="left"
          variant="subtle"
          inventoryItem={{
            id: tag.id,
            name: `#${tag.tagData.tagNumber}`,
            itemGroupId: tag.tagData.item.itemGroup?.id,
          }}
          rightElement={
            <div>
              {humanReadableValue(tag.tagData.netQuantity, 'number')} lb
            </div>
          }
          itemSubtitle={
            <div className="text-sm opacity-60">{tag.tagData.item.name}</div>
          }
          onPress={() => onSelectTag(tag.id, tag.tagData)}
        />
      ))}
    </div>
  );
};
